const configplugin = {
  getConfig(){
    return new Promise(function (resolve,reject) {
      fetch('/configs/config.json').then(res => res.json())
      .catch(error => reject(error))
      .then(response => {
        resolve(response)
      })
    })
  }
}
export default configplugin;